import { render, staticRenderFns } from "./UserBalanceLog.vue?vue&type=template&id=32b7b133&scoped=true&"
import script from "./UserBalanceLog.vue?vue&type=script&lang=js&"
export * from "./UserBalanceLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7b133",
  null
  
)

export default component.exports